module.exports = __webpack_public_path__ + "static/img/szafa_42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_42.jpg
// module id = eyDG
// module chunks = 0